import ReceivingMethodModal from './ReceivingMethodModal';

export default ReceivingMethodModal;
